import React from "react";
import { BsArrowLeft } from "react-icons/bs";
import "react-circular-progressbar/dist/styles.css";
// @ts-ignore
import Image from "../../Assets/Images/Sat-images/second-Arrow .webp";
// @ts-ignore
import Girl from "../../Assets/Images/Sat-images/girl-img-.webp";

export interface MockTestBannerProps {
  title: string;
  check?: boolean;
  subTitle?: string;
  nolesson?: string | number;
}

const MockTestBanner: React.FC<MockTestBannerProps> = (props) => {
  return (
    <>
      <div className="subbanner-container">
        <div className="sub-banner-first-section">
          <div className="heading-icon-section">
            <div>{props.check === true ? <BsArrowLeft size="14px" /> : ""}</div>
            <div className="sub-banner-title">
              <p>
                SAT
                <span className="sub-banner-title-span">
                  {props.title}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="sub-banner-second-section mock-main-banner">
          <div className="second-section-left mock-second-left">
            <div>
              <h3 className="heading-sub-banner mock-banner-heading">
                {props.subTitle}
              </h3>
            </div>
            <div className=" progress-panel">Start Now</div>
          </div>
          <div className="second-section-right mock-banner-second">
            <div className="mock-second-section-image">
              <img src={Image} width="80px" height="60px" alt="Arrow" />
            </div>
            <div>
              <img src={Girl} width="120px" height="120px" alt="Girl" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default React.memo(MockTestBanner);
